export default function Getting_Started() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Getting_Started</h1>
      <p>Content for Getting_Started goes here.</p>
    </div>
  );
}